var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      stroke: "#000000",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9,26 C 17.5,24.5 30,24.5 36,26 L 38.5,13.5 L 31,25 L 30.7,10.9 L 25.5,24.5 L 22.5,10 L 19.5,24.5 L 14.3,10.9 L 14,25 L 6.5,13.5 L 9,26 z",
    style: {
      strokeLinecap: "butt",
      fill: "#000000"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 9,26 c 0,2 1.5,2 2.5,4 1,1.5 1,1 0.5,3.5 -1.5,1 -1,2.5 -1,2.5 -1.5,1.5 0,2.5 0,2.5 6.5,1 16.5,1 23,0 0,0 1.5,-1 0,-2.5 0,0 0.5,-1.5 -1,-2.5 -0.5,-2.5 -0.5,-2 0.5,-3.5 1,-2 2.5,-2 2.5,-4 -8.5,-1.5 -18.5,-1.5 -27,0 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 11.5,30 C 15,29 30,29 33.5,30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 12,33.5 c 6,-1 15,-1 21,0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 9,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 8,
    r: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 9,
    r: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 12,
    r: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 11,38.5 A 35,35 1 0 0 34,38.5",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "butt"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#ffffff"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 11,29 A 35,35 1 0 1 34,29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 12.5,31.5 L 32.5,31.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 11.5,34.5 A 35,35 1 0 0 33.5,34.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.5,37.5 A 35,35 1 0 0 34.5,37.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBq);
export default __webpack_public_path__ + "static/media/bq.7ad54c32945c6a44aa72074a48391dfd.svg";
export { ForwardRef as ReactComponent };